import root from 'window-or-global';
import $ from 'jquery';
import Marionette from 'backbone.marionette';

import PageView from '../../../base/views/page';
import { SearchView } from '../../../base/views/search';

const ItemView = Marionette.LayoutView.extend({
  tagName: 'tr',
  className() {
    return this.options.className;
  },

  template: require('../../templates/transaction/row.html')
});

const TransactionListView = Marionette.CompositeView.extend({
  tagName: 'table',
  className: 'datatable',
  template: require('../../templates/transaction/table.html'),
  childView: ItemView,
  childViewContainer: 'tbody',

  childViewOptions(model, index) {
    const can_import = model.get('can_import');

    return {
      className: `${index % 2 ? '' : 'alt'} ${can_import ? '' : 'inactive'}`
    };
  }
});

const TransactionView = Marionette.LayoutView.extend({
  template: require('../../templates/transaction/index.html'),

  regions: {
    transactions: '#table-hook',
    paging: '.page-hook',
    search: '.search-hook'
  },

  ui: {
    importTransactions: '.import-button',
    hideSelected: '.hide-selected-button',
    toggleHidden: '.show-hidden-button',
    sync: '.sync-button',
    showZeroValue: '.show-zero-value-button'
  },

  events: {
    'click @ui.importTransactions': 'importPage',
    'click @ui.hideSelected': 'hideSelectedTransactions',
    'click @ui.toggleHidden': 'fetchHiddenTransactions',
    'click @ui.sync': 'syncWithParentPay',
    'click @ui.showZeroValue': 'fetchZeroValueTransactions'
  },

  onShow() {
    const search = new SearchView({ collection: this.collection });
    const transactions = new TransactionListView({
      collection: this.collection
    });
    const page = new PageView({ collection: this.collection });

    this.showChildView('search', search);
    this.showChildView('transactions', transactions);
    this.showChildView('paging', page);
  },

  hideSelectedTransactions() {
    const selectedIds = [];
    this.$('.transaction-select:checked').each(function () {
      selectedIds.push($(this).val());
    });

    if (!selectedIds.length) {
      root.messages.add('Please show_hidden_txns at least one transaction to hide.');
      return;
    }

    $.ajax({
      type: 'POST',
      data: { "txnIds": selectedIds },
      success: () => {
        root.messages.add('Transactions have been toggled.');
        this.collection.fetch();
      },
      error: (errorThrown) => {
        root.messages.add('Error hiding transactions: ' + errorThrown, 'error');
      }
    });
  },

  /**
   * Import the transactions displayed on the page.
   * @returns {undefined}
   */
  importPage() {
    $.ajax({
      type: 'post',
      url: '/parentpay/import/',
      success: () => {
        root.messages.add('Imported transactions.');
        this.collection.fetch();
      }
    });
  },

  /**
   * Run the ParentPay Sync Task.
   * @returns {undefined}
   */
  syncWithParentPay() {
    $.ajax({
      type: 'post',
      url: '/parentpay/import/sync/',
      success() {
        root.messages.add(
          'Started sync. Check back in a few minutes',
          'success'
        );
      }
    });
  },

  fetchZeroValueTransactions() {
    const showZeroValue = this.collection.search_params.show_zero_value;

    const showText = 'Show Zero Value Transactions';
    const hideText = 'Hide Zero Value Transactions';

    const zeroValueButtonText = showZeroValue == 'True' ? showText : hideText;

    $('.show-zero-value-button').text(zeroValueButtonText);

    this.collection.search_params.show_zero_value = showZeroValue === 'True' ? 'False' : 'True';
    this.collection.fetch();
  },

  fetchHiddenTransactions() {
    const showHidden = this.collection.search_params.show_hidden_txns;
    const showText = 'Show Hidden';
    const hideText = 'Hide Hidden';

    const showHiddenButtonText = showHidden == 'True' ? showText : hideText;

    $('.show-hidden-button').text(showHiddenButtonText);
    this.collection.search_params.show_hidden_txns = showHidden === 'True' ? 'False' : 'True';
    this.collection.fetch();
  }
});

module.exports = TransactionView;



// WEBPACK FOOTER //
// ./parentpay/views/transaction/index.js